import type { KochBestellungAnsicht } from "../api";
import { euro } from "../geld";

interface Props {
  bestellung: KochBestellungAnsicht;
  beschaeftigt: boolean;
  onAnnehmen: (id: string) => void;
  onAblehnen: (id: string) => void;
  onErledigen: (id: string) => void;
}

/** Eine Karte der Live-Liste: Status, Kanal, Kontakt, Adresse, Zeilen, Summe, Wartedauer und
 *  die für den Status passenden Koch-Übergänge. */
export function BestellKarte({
  bestellung,
  beschaeftigt,
  onAnnehmen,
  onAblehnen,
  onErledigen,
}: Props) {
  const minuten = minutenSeit(bestellung.erstelltAm);

  return (
    <li className={`bestell-karte status-${bestellung.status.toLowerCase()}`}>
      <div className="bestell-kopf">
        <span className={`status-plakette ${bestellung.status.toLowerCase()}`}>
          {bestellung.status}
        </span>
        <span className="kanal-plakette">
          {bestellung.kanal === "LIEFERUNG" ? "Lieferung" : "Abholung"}
        </span>
        <span className="wartedauer">vor {minuten} Min</span>
      </div>

      <div className="bestell-kontakt">
        <span>☎ {bestellung.telefon}</span>
        {bestellung.lieferadresse && (
          <span className="adresse-zeile-anzeige">
            {bestellung.lieferadresse.strasse} {bestellung.lieferadresse.hausnummer},{" "}
            {bestellung.lieferadresse.plz} {bestellung.lieferadresse.ort}
          </span>
        )}
      </div>

      <ul className="bestell-zeilen">
        {bestellung.zeilen.map((zeile, i) => (
          <li key={`${zeile.name}-${i}`}>
            <span>{zeile.name}</span>
            <span>{euro(zeile.zeilensummeCent)}</span>
          </li>
        ))}
      </ul>

      <div className="bestell-fuss">
        <span className="summe">Gesamt: {euro(bestellung.gesamtsummeCent)}</span>
        {bestellung.wartezeitMin != null && (
          <span className="eta">ETA {bestellung.wartezeitMin} Min</span>
        )}
      </div>

      {bestellung.ablehnungsgrund && (
        <p className="ablehnungsgrund">Abgelehnt: {bestellung.ablehnungsgrund}</p>
      )}

      <div className="knopf-reihe">
        {bestellung.status === "NEU" && (
          <>
            <button
              type="button"
              className="knopf primaer"
              disabled={beschaeftigt}
              onClick={() => onAnnehmen(bestellung.id)}
            >
              Annehmen
            </button>
            <button
              type="button"
              className="knopf gefahr"
              disabled={beschaeftigt}
              onClick={() => onAblehnen(bestellung.id)}
            >
              Ablehnen
            </button>
          </>
        )}
        {bestellung.status === "ANGENOMMEN" && (
          <button
            type="button"
            className="knopf primaer"
            disabled={beschaeftigt}
            onClick={() => onErledigen(bestellung.id)}
          >
            Erledigt
          </button>
        )}
      </div>
    </li>
  );
}

/** Ganze Minuten seit einem ISO-Zeitstempel; nie negativ. */
function minutenSeit(iso: string): number {
  const diff = Date.now() - Date.parse(iso);
  return Math.max(0, Math.floor(diff / 60_000));
}
